import React from 'react';
import { useNavigate } from 'react-router-dom';

const UpperArmPT = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        .upperArm-page {
          min-height: 100vh;
          width: 100%;
          background: radial-gradient(circle at top left, #e0f2fe 0, #f9fafb 45%, #e5e7eb 100%);
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          color: #0f172a;
        }

        .upperArm-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 32px 16px 72px;
        }

        /* HERO */
        .upperArm-hero {
          padding: 26px 18px 30px;
          border-radius: 26px;
          background: linear-gradient(120deg, rgba(37, 99, 235, 0.1), rgba(59, 130, 246, 0.03));
          display: grid;
          grid-template-columns: minmax(0, 1.5fr) minmax(0, 1.2fr);
          gap: 24px;
          align-items: center;
          margin-bottom: 32px;
        }

        @media (max-width: 820px) {
          .upperArm-hero {
            grid-template-columns: 1fr;
          }
        }

        .upperArm-tag {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 5px 12px;
          border-radius: 999px;
          background: rgba(59, 130, 246, 0.15);
          color: #1d4ed8;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          margin-bottom: 10px;
        }

        .upperArm-tag-dot {
          width: 6px;
          height: 6px;
          border-radius: 999px;
          background: #1d4ed8;
        }

        .upperArm-title {
          font-size: clamp(27px, 4vw, 36px);
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 10px;
        }

        .upperArm-subtitle {
          font-size: 15px;
          max-width: 540px;
          line-height: 1.5;
          color: #1f2937;
        }

        .upperArm-heroChips {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin: 14px 0 16px;
        }

        .upperArm-chip {
          padding: 6px 11px;
          border-radius: 999px;
          background: rgba(15, 23, 42, 0.92);
          color: #f9fafb;
          font-size: 11px;
        }

        .upperArm-ctaRow {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 8px;
        }

        .upperArm-btnPrimary,
        .upperArm-btnSecondary {
          border-radius: 999px;
          border: none;
          font-size: 14px;
          padding: 9px 18px;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          transition: transform 0.12s ease, box-shadow 0.12s ease, background 0.12s ease;
        }

        .upperArm-btnPrimary {
          background: #2563eb;
          color: #f9fafb;
          box-shadow: 0 9px 22px rgba(37, 99, 235, 0.35);
        }

        .upperArm-btnPrimary:hover {
          transform: translateY(-1px);
          box-shadow: 0 12px 28px rgba(37, 99, 235, 0.45);
        }

        .upperArm-btnSecondary {
          background: rgba(15, 23, 42, 0.04);
          color: #111827;
          border: 1px solid rgba(148, 163, 184, 0.7);
        }

        .upperArm-btnSecondary:hover {
          background: rgba(15, 23, 42, 0.1);
          transform: translateY(-1px);
        }

        .upperArm-heroSmall {
          font-size: 11px;
          margin-top: 10px;
          color: #6b7280;
        }

        .upperArm-heroImageWrap {
          display: flex;
          justify-content: center;
        }

        .upperArm-heroImage {
          width: 100%;
          max-width: 380px;
          border-radius: 24px;
          object-fit: cover;
          box-shadow: 0 18px 38px rgba(15, 23, 42, 0.28);
        }

        /* STRIPES */
        .upperArm-stripe {
          padding: 28px 0;
          border-bottom: 1px solid rgba(148, 163, 184, 0.45);
        }

        .upperArm-sectionTitle {
          font-size: 19px;
          font-weight: 700;
          margin-bottom: 8px;
        }

        .upperArm-sectionSubtitle {
          font-size: 13px;
          color: #4b5563;
          margin-bottom: 14px;
        }

        .upperArm-flexRow {
          display: flex;
          flex-wrap: wrap;
          gap: 22px;
          align-items: center;
        }

        .upperArm-flexCol {
          flex: 1 1 260px;
        }

        .upperArm-inlineImage {
          width: 100%;
          max-width: 360px;
          border-radius: 22px;
          object-fit: cover;
          box-shadow: 0 14px 30px rgba(15, 23, 42, 0.18);
        }

        .upperArm-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: grid;
          gap: 7px;
        }

        .upperArm-list li {
          display: flex;
          gap: 8px;
          font-size: 14px;
          color: #111827;
        }

        .upperArm-bullet {
          width: 7px;
          height: 7px;
          border-radius: 999px;
          margin-top: 6px;
          background: #2563eb;
          flex-shrink: 0;
        }

        /* 2-COLUMN INFO STRIP */
        .upperArm-duo {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 16px;
          margin-top: 14px;
        }

        .upperArm-duoCard {
          padding: 11px 13px;
          border-radius: 18px;
          background: rgba(15, 23, 42, 0.02);
          border: 1px solid rgba(148, 163, 184, 0.5);
        }

        .upperArm-duoTitle {
          font-size: 13px;
          font-weight: 600;
          margin-bottom: 4px;
        }

        .upperArm-duoText {
          font-size: 12px;
          color: #4b5563;
        }

        /* TIMELINE / LOW-ATTENTION VISUAL */
        .upperArm-timeline {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
          gap: 10px;
          margin-top: 12px;
        }

        .upperArm-step {
          border-radius: 18px;
          padding: 10px 12px;
          background: rgba(15, 23, 42, 0.03);
        }

        .upperArm-stepLabel {
          font-size: 12px;
          font-weight: 600;
          margin-bottom: 4px;
        }

        .upperArm-stepText {
          font-size: 12px;
          color: #4b5563;
        }

        /* FULL-WIDTH BANNER */
        .upperArm-banner {
          position: relative;
          border-radius: 26px;
          overflow: hidden;
          margin-top: 18px;
        }

        .upperArm-banner img {
          width: 100%;
          height: 220px;
          object-fit: cover;
          display: block;
        }

        @media (min-width: 768px) {
          .upperArm-banner img {
            height: 260px;
          }
        }

        .upperArm-bannerOverlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, rgba(15, 23, 42, 0.78), transparent 55%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 18px 20px;
          gap: 8px;
        }

        .upperArm-bannerText {
          color: #e5e7eb;
          font-size: 15px;
          max-width: 420px;
        }

        .upperArm-bannerButtons {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin-top: 6px;
        }

        .upperArm-bannerButtons button {
          font-size: 12px;
          padding: 7px 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .upperArm-bannerButtons .primary {
          background: #22c55e;
          color: #022c22;
        }

        .upperArm-bannerButtons .secondary {
          background: rgba(15, 23, 42, 0.35);
          color: #f9fafb;
          border: 1px solid rgba(209, 213, 219, 0.7);
        }

        /* BOTTOM WARNING STRIP */
        .upperArm-bottomStrip {
          margin-top: 24px;
          padding: 14px 14px;
          border-radius: 22px;
          background: #0f172a;
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          align-items: center;
          justify-content: space-between;
        }

        .upperArm-bottomText {
          font-size: 12px;
          color: #e5e7eb;
          flex: 1 1 240px;
        }

        .upperArm-bottomText strong {
          color: #fef9c3;
        }

        .upperArm-bottomActions {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .upperArm-bottomActions button {
          font-size: 12px;
          padding: 7px 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .upperArm-bottomActions .primary {
          background: #2563eb;
          color: #f9fafb;
        }

        .upperArm-bottomActions .secondary {
          background: transparent;
          color: #e5e7eb;
          border: 1px solid rgba(148, 163, 184, 0.8);
        }

        @media (max-width: 640px) {
          .upperArm-title {
            font-size: 25px;
          }
        }
      `}</style>

      <div className="upperArm-page">
        <div className="upperArm-inner">
          {/* ===== HERO ===== */}
          <section className="upperArm-hero">
            <div>
              <div className="upperArm-tag">
                <span className="upperArm-tag-dot" />
                Upper Arm & Biceps Relief
              </div>
              <h1 className="upperArm-title">
                Ease upper arm pain and get back to lifting, reaching, and carrying.
              </h1>
              <p className="upperArm-subtitle">
                The upper arm muscles (like the biceps and brachialis) help bend the elbow,
                hold objects, and control everyday movements. When they&apos;re irritated,
                you feel it every time you reach or pull.
              </p>

              <div className="upperArm-heroChips">
                <span className="upperArm-chip">Biceps soreness with lifting</span>
                <span className="upperArm-chip">Pain holding bags or kids</span>
                <span className="upperArm-chip">Strain after workouts</span>
                <span className="upperArm-chip">Tenderness at the front of the upper arm</span>
              </div>

              <div className="upperArm-ctaRow">
                <button
                  className="upperArm-btnPrimary"
                  onClick={() => navigate('/appointments')}
                >
                  Book an upper arm visit →
                </button>
                <button
                  className="upperArm-btnSecondary"
                  onClick={() => navigate('/staff')}
                >
                  Meet our therapists
                </button>
              </div>

              <p className="upperArm-heroSmall">
                You don&apos;t have to stop using your arm completely. PT can help you find what&apos;s safe,
                while things calm down and rebuild.
              </p>
            </div>

            <div className="upperArm-heroImageWrap">
              <img
                src="/content/upper-arm/upper_arm_hero.jpg"
                alt="Therapist assessing a patient’s upper arm and biceps"
                className="upperArm-heroImage"
              />
            </div>
          </section>

          {/* ===== STRIPE 1 – WHAT CAN GO WRONG ===== */}
          <section className="upperArm-stripe">
            <div className="upperArm-sectionTitle">What can go wrong in the upper arm?</div>
            <p className="upperArm-sectionSubtitle">
              The upper arm isn&apos;t just “biceps.” Deeper muscles like the brachialis and
              surrounding tissue help flex the elbow and control load — and they can all get irritated.
            </p>

            <div className="upperArm-flexRow">
              <div className="upperArm-flexCol">
                <ul className="upperArm-list">
                  <li>
                    <span className="upperArm-bullet" />
                    <span>
                      <strong>Biceps strain or overuse:</strong> pain in the front of the upper arm
                      after lifting, pulling, or heavy workouts.
                    </span>
                  </li>
                  <li>
                    <span className="upperArm-bullet" />
                    <span>
                      <strong>Brachialis irritation:</strong> deep ache under the biceps that can
                      make bending the elbow uncomfortable.
                    </span>
                  </li>
                  <li>
                    <span className="upperArm-bullet" />
                    <span>
                      <strong>“Tendon” soreness:</strong> tenderness near the elbow or shoulder where
                      upper arm muscles attach.
                    </span>
                  </li>
                  <li>
                    <span className="upperArm-bullet" />
                    <span>
                      <strong>Post-surgery or injury stiffness:</strong> limited motion or weakness
                      after a repair, fracture, or immobilization.
                    </span>
                  </li>
                  <li>
                    <span className="upperArm-bullet" />
                    <span>
                      <strong>Referred pain:</strong> symptoms coming from the neck or shoulder that
                      still show up in the upper arm.
                    </span>
                  </li>
                </ul>

                <div className="upperArm-ctaRow" style={{ marginTop: '14px' }}>
                  <button
                    className="upperArm-btnPrimary"
                    onClick={() => navigate('/appointments')}
                  >
                    See if your upper arm symptoms fit →
                  </button>
                  <button
                    className="upperArm-btnSecondary"
                    onClick={() => navigate('/contact')}
                  >
                    Ask a quick question
                  </button>
                </div>
              </div>

              <div className="upperArm-flexCol" style={{ display: 'flex', justifyContent: 'center' }}>
                <img
                  src="/content/upper-arm/upper_arm_strength_test.jpg"
                  alt="Therapist testing elbow flexion strength of the upper arm"
                  className="upperArm-inlineImage"
                />
              </div>
            </div>

            <div className="upperArm-duo">
              <div className="upperArm-duoCard">
                <div className="upperArm-duoTitle">Biceps brachii</div>
                <div className="upperArm-duoText">
                  The more visible “front of the arm” muscle that helps bend the elbow and turn the palm up.
                </div>
              </div>
              <div className="upperArm-duoCard">
                <div className="upperArm-duoTitle">Brachialis (deep)</div>
                <div className="upperArm-duoText">
                  Sits underneath the biceps and does a lot of the heavy lifting when you bend your elbow.
                </div>
              </div>
            </div>
          </section>

          {/* ===== STRIPE 2 – HOW PT HELPS (MANUAL) ===== */}
          <section className="upperArm-stripe">
            <div className="upperArm-flexRow">
              <div className="upperArm-flexCol" style={{ order: 2 }}>
                <div className="upperArm-sectionTitle">How physical therapy helps the upper arm</div>
                <p className="upperArm-sectionSubtitle">
                  We target the irritated tissue, support what&apos;s doing too much, and retrain
                  how the arm handles load so you can trust it again.
                </p>

                <ul className="upperArm-list">
                  <li>
                    <span className="upperArm-bullet" />
                    <span>
                      <strong>Soft-tissue work:</strong> gentle, focused treatment to the biceps,
                      brachialis, and surrounding muscles to reduce tightness and soreness.
                    </span>
                  </li>
                  <li>
                    <span className="upperArm-bullet" />
                    <span>
                      <strong>Range-of-motion work:</strong> restoring comfortable bending and
                      straightening of the elbow without sharp pain.
                    </span>
                  </li>
                  <li>
                    <span className="upperArm-bullet" />
                    <span>
                      <strong>Load management:</strong> adjusting how much weight, how often, and
                      how quickly you load the arm during recovery.
                    </span>
                  </li>
                  <li>
                    <span className="upperArm-bullet" />
                    <span>
                      <strong>Support from the shoulder:</strong> making sure the shoulder and shoulder
                      blade help share the work.
                    </span>
                  </li>
                  <li>
                    <span className="upperArm-bullet" />
                    <span>
                      <strong>Scar or post-op care (if needed):</strong> helping tissue move well
                      after surgery or immobilization.
                    </span>
                  </li>
                </ul>

                <div className="upperArm-ctaRow" style={{ marginTop: '14px' }}>
                  <button
                    className="upperArm-btnPrimary"
                    onClick={() => navigate('/appointments')}
                  >
                    Start with one upper arm session →
                  </button>
                  <button
                    className="upperArm-btnSecondary"
                    onClick={() => navigate('/insurance')}
                  >
                    Check my insurance
                  </button>
                </div>
              </div>

              <div className="upperArm-flexCol" style={{ order: 1, display: 'flex', justifyContent: 'center' }}>
                <img
                  src="/content/upper-arm/upper_arm_manual.jpg"
                  alt="Manual therapy applied to the front of the upper arm"
                  className="upperArm-inlineImage"
                />
              </div>
            </div>
          </section>

          {/* ===== STRIPE 3 – VISIT FLOW + EXERCISES ===== */}
          <section className="upperArm-stripe">
            <div className="upperArm-flexRow">
              <div className="upperArm-flexCol">
                <img
                  src="/content/upper-arm/upper_arm_exercises.jpg"
                  alt="Patient performing upper arm exercises with guidance"
                  className="upperArm-inlineImage"
                />
              </div>

              <div className="upperArm-flexCol">
                <div className="upperArm-sectionTitle">What an upper arm visit may look like</div>
                <p className="upperArm-sectionSubtitle">
                  The plan is tailored to you, but sessions usually follow a clear, easy-to-follow rhythm:
                </p>

                <div className="upperArm-timeline">
                  <div className="upperArm-step">
                    <div className="upperArm-stepLabel">1. Your story</div>
                    <div className="upperArm-stepText">
                      You share how the pain started, what motions bring it on, and what you need your arm for most.
                    </div>
                  </div>
                  <div className="upperArm-step">
                    <div className="upperArm-stepLabel">2. Motion & strength check</div>
                    <div className="upperArm-stepText">
                      We look at elbow motion, upper arm strength, and how your shoulder and neck join in.
                    </div>
                  </div>
                  <div className="upperArm-step">
                    <div className="upperArm-stepLabel">3. Hands-on care</div>
                    <div className="upperArm-stepText">
                      You try one or two manual techniques or stretches to see what eases the area.
                    </div>
                  </div>
                  <div className="upperArm-step">
                    <div className="upperArm-stepLabel">4. Simple home plan</div>
                    <div className="upperArm-stepText">
                      You leave with a small set of movements and do/don&apos;t guidelines you can remember.
                    </div>
                  </div>
                </div>

                <div className="upperArm-ctaRow" style={{ marginTop: '14px' }}>
                  <button
                    className="upperArm-btnPrimary"
                    onClick={() => navigate('/appointments')}
                  >
                    Book an upper arm evaluation →
                  </button>
                  <button
                    className="upperArm-btnSecondary"
                    onClick={() => navigate('/contact')}
                  >
                    Talk to our team first
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* ===== BANNER (YOU CAN REUSE CLINIC IMAGE OR MAKE A NEW ONE) ===== */}
          <section className="upperArm-stripe">
            <div className="upperArm-banner">
              <img
                src="/content/upper-arm/upper_arm_banner.jpg"
                alt="Bright physical therapy clinic where upper arm rehab takes place"
              />
              <div className="upperArm-bannerOverlay">
                <div className="upperArm-bannerText">
                  Upper arm sessions happen in a calm, one-on-one clinic setting where we can focus
                  on your goals — from everyday tasks to specific sports or work demands.
                </div>
                <div className="upperArm-bannerButtons">
                  <button
                    className="primary"
                    onClick={() => navigate('/appointments')}
                  >
                    Schedule my upper arm visit →
                  </button>
                  <button
                    className="secondary"
                    onClick={() => navigate('/office')}
                  >
                    View locations
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* ===== BOTTOM WARNING ===== */}
          <section className="upperArm-stripe">
            <div className="upperArm-bottomStrip">
              <div className="upperArm-bottomText">
                If you notice a sudden “pop” in the upper arm, a visible bulge, severe bruising, or
                you can&apos;t use the arm at all,{" "}
                <strong>seek medical or emergency care first.</strong> Physical therapy can then support
                your recovery and safe return to activity.
              </div>
              <div className="upperArm-bottomActions">
                <button
                  className="primary"
                  onClick={() => navigate('/appointments')}
                >
                  Schedule upper arm PT
                </button>
                <button
                  className="secondary"
                  onClick={() => navigate('/contact')}
                >
                  Message our team
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default UpperArmPT;
